
import DOMPurify from 'dompurify';
import Quill, { QuillOptionsStatic, RangeStatic } from 'quill';
import QuillEditor from './QuillEditor.vue';

const Clipboard = Quill.import('modules/clipboard');
class PlainClipboard extends Clipboard {
  sanitizeHtml(html: string): string {
    html = html.replace(/\r?\n +/g, '><'); // Remove spaces between tags

    html = DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'b',
        'strong',
        'i',
        'em', // italic
        'u',
        'span',
        'p',
        'a',
        'br', //break
        'ol',
        'ul',
        'li',
        'img',
        'image'
      ],
      FORBID_ATTR: ['style']
    });

    return html;
  }

  onPaste(range: RangeStatic, { text, html }: { text: string; html: string }) {
    html = this.sanitizeHtml(html);
    return super.onPaste(range, { text, html });
  }
}

export default QuillEditor.extend({
  name: 'QuillPDFEditor',

  data() {
    return {
      defaultOptions: {
        modules: {
          // disabled table module as PDF cannot render tables

          table: false,
          toolbar: [['bold', 'italic', 'underline', 'link']]
        },
        formats: [
          'bold',
          'italic',
          'link',
          'underline',
          'header',
          'indent',
          'list',
          'align',
          'direction'
        ]
      } as QuillOptionsStatic
    };
  },

  created() {
    Quill.register('modules/clipboard', PlainClipboard, true);
  },

  /**
   * The beforedetroy on the parent QuillEditor will also be called before this beforeDestroy hook.
   * when extending components option hooks are merged into an array so that all of them will be
   * called, starting from the parent to its children.
   * @see {@link QuillEditor}
   */
  beforeDestroy() {
    // reset clipboard module when unmounting this editor
    Quill.register('modules/clipboard', Clipboard, true);
  }
});
